import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { MockCacheLoadListenerComponent } from './cache-load-listener/mock-cache-load-listener.component'
import { MockNoLoadedAccountComponent } from './content-guards/no-loaded-account/mock-no-loaded-account.component'
import { MockResizeHandleComponent } from './resize-handle/mock-resize-handle.component'
import { MockSecuritiesSelectedComponent } from './securities-selected/mock-securities-selected.component'
import { MockSingleAccountSelectedComponent } from './single-account-selected/mock-single-account-selected.component'

@NgModule({
  imports: [CommonModule],
  declarations: [
    MockNoLoadedAccountComponent,
    MockCacheLoadListenerComponent,
    MockSecuritiesSelectedComponent,
    MockResizeHandleComponent,
    MockSingleAccountSelectedComponent,
  ],
  exports: [
    MockNoLoadedAccountComponent,
    MockCacheLoadListenerComponent,
    MockSecuritiesSelectedComponent,
    MockResizeHandleComponent,
    MockSingleAccountSelectedComponent,
  ],
})
export class FakeGenericComponentsModule {}
